import React from 'react';
import useMedia from 'use-media';
import Brands, { BrandObject } from '../../../Brands';
import ThreeDCarousel from '../../../ThreeDCarousel';
import CustomerCarouselItem, {
  CustomerCarouselItemVariant,
} from './CustomerCarouselItem';
import { useContentfulImage } from 'gatsby-source-contentful/hooks';

interface CustomerCarouselProps {
  carouselData: {
    id: string;
    text: string;
    logo: string;
    img: string;
    link: string;
    variant: null | string;
  }[]
}

const CustomerCarousel: React.FC<CustomerCarouselProps> = props => {
  const { carouselData } = props;

  const storiesSlides = carouselData.map((story, idx) => {

    const background = useContentfulImage({
      image: {
        url: story.img.split('https:')[1],
        width: 954,
        height: 500,
        quality: 100,
      },
    });

    return {
      key: idx,
      content: (
        <CustomerCarouselItem
          text={story.text}
          backgroundImageURL={background}
          customerLogoSVG={story.logo}
          onClick={() => window?.open(story.link, '_blank')}
          variant={
            story.variant == 'video'
              ? CustomerCarouselItemVariant.video
              : CustomerCarouselItemVariant.text
          }
        />
      )
    }
  });
  const [carouselIndex, setCarouselIndex] = React.useState<number>(0);
  const interval = React.useRef(null);
  const isTablet = useMedia({ minWidth: '768px' });
  const isDesktop = useMedia({ minWidth: '1024px' });

  const brandsList: BrandObject[] = carouselData.map((story, idx) => ({
    src: story.logo,
    filter: carouselIndex !== idx,
    onClick: () => setCarouselIndex(idx),
  }));

  let size: React.CSSProperties = {
    height: '247px',
  };
  if (isDesktop) {
    size = {
      height: '500px',
    };
  } else if (isTablet) {
    size = {
      height: '247px',
    };
  }

  React.useEffect(() => {
    interval.current = setInterval(() => {
      setCarouselIndex((carouselIndex + 1) % 5);
    }, 8000);
    return () => {
      clearInterval(interval?.current);
    };
  }, [carouselIndex]);

  return (
    <div className="relative">
      <div style={{ ...size }} className="lg:mb-16 mb-12">
        <ThreeDCarousel items={storiesSlides} index={carouselIndex} />
      </div>
      <Brands brandsList={brandsList} />
    </div>
  );
};

export default CustomerCarousel;
